// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { apiClient } from './client'
import type { WebhookEndpoint, DeliveryLog, WebhookEvent } from '@/types'

export interface CreateWebhookPayload {
  url: string
  description?: string
  events: WebhookEvent[]
}

export const webhooksApi = {
  list: () => apiClient.get<WebhookEndpoint[]>('/v1/webhooks'),

  getById: (id: string) => apiClient.get<WebhookEndpoint>(`/v1/webhooks/${id}`),

  create: (payload: CreateWebhookPayload) =>
    apiClient.post<WebhookEndpoint>('/v1/webhooks', payload),

  update: (id: string, payload: Partial<CreateWebhookPayload & { enabled: boolean }>) =>
    apiClient.patch<WebhookEndpoint>(`/v1/webhooks/${id}`, payload),

  delete: (id: string) => apiClient.delete(`/v1/webhooks/${id}`),

  getDeliveryLogs: (id: string) =>
    apiClient.get<DeliveryLog[]>(`/v1/webhooks/${id}/logs`),

  retry: (webhookId: string, logId: string) =>
    apiClient.post<DeliveryLog>(`/v1/webhooks/${webhookId}/logs/${logId}/retry`),
}
